/**
 * Asynchronously loads the component
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'), {
  fallback: null,
});